import React, { useState, useEffect } from "react";

const Sidebar = ({ mainMenuItems = [], menuItems = [] }) => {
  const [activeItem, setActiveItem] = useState();
  const path = location.pathname

  // for page refersh current active menus 
  useEffect(() => {
    const currentActiveItem = [...mainMenuItems, ...menuItems].find(item => path.startsWith(`/${item.key}`))
    setActiveItem(currentActiveItem?.id);
  }, [mainMenuItems.length, menuItems.length, path]);


  const handleItemClick = (item) => {
    setActiveItem(item.id);
    if (item.clickHandler) {
      item.clickHandler();
    }
  };

  return (
    <div className="sidebarmenu">
      {mainMenuItems.length>0 &&
        <div className="menubtn">
          <ul>
            {mainMenuItems?.map((item) => (
              <li key={item.id} className={activeItem === item.id ? "active" : ""} onClick={() => handleItemClick(item)}>
                <div className="sidetooltip">
                  <span>{item.icon}</span>
                  <p className="tooltiptext">{item.tooltip}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      }
     {!!menuItems.length && <div className="menubtn">
        <ul className="mainlist">
          {menuItems?.map((item) => (
            <li key={item.id} className={activeItem === item.id ? "active" : ""} onClick={() => handleItemClick(item)}>
              <div className="sidetooltip">
                <span>{item.icon}</span>
                <p className="tooltiptext">{item.tooltip}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>}
    </div>
  );
};

export default Sidebar;
